export const ingameCommands = [
  {
    cmd: "pop",
    plan: 1,
    img: ["pop"],
    translate: "Commands.popDesc",
  },
  {
    cmd: "time",
    plan: 1,
    img: ["time"],
    translate: "Commands.timeDesc",
  },
  {
    cmd: "silence [time]",
    plan: 1,
    img: ["silence"],
    translate: "Commands.silenceDesc",
  },
  {
    cmd: "resume",
    plan: 1,
    img: ["resume"],
    translate: "Commands.resumeDesc",
  },
  {
    cmd: "afk",
    plan: 1,
    img: ["afkCommand"],
    translate: "Commands.afkDesc",
  },
  {
    cmd: "alive",
    plan: 1,
    img: ["alive"],
    translate: "Commands.aliveDesc",
  },
  {
    cmd: "online",
    plan: 1,
    img: ["online"],
    translate: "Commands.onlineDesc",
  },
  {
    cmd: "offline",
    plan: 1,
    img: ["offline"],
    translate: "Commands.offlineDesc",
  },
  {
    cmd: "proximity / prox",
    plan: 1,
    img: ["proximity"],
    translate: "Commands.proximityDesc",
  },
  {
    cmd: "bot",
    plan: 1,
    img: ["bot"],
    translate: "Commands.botDesc",
  },
  {
    cmd: "alarm [time] [name]",
    plan: 2,
    img: ["alarm"],
    translate: "Commands.alarmDesc",
  },
  {
    cmd: "remain",
    plan: 2,
    img: ["remain"],
    translate: "Commands.remainDesc",
  },
  {
    cmd: "stop [id]",
    plan: 2,
    img: ["stop"],
    translate: "Commands.stopDesc",
  },
  {
    cmd: "leader",
    plan: 2,
    img: ["leader"],
    translate: "Commands.leaderDesc",
  },
  {
    cmd: "leader [name]",
    plan: 2,
    img: ["leader2"],
    translate: "Commands.leader2Desc",
  },
  {
    cmd: "cargo",
    plan: 2,
    img: ["cargo"],
    translate: "Commands.cargoDesc",
  },
  {
    cmd: "small",
    plan: 2,
    img: ["small"],
    translate: "Commands.smallDesc",
  },
  {
    cmd: "large",
    plan: 2,
    img: ["large"],
    translate: "Commands.largeDesc",
  },
  {
    cmd: "heli",
    plan: 2,
    img: ["heli"],
    translate: "Commands.heliDesc",
  },
];

export const discordCommands = [
  {
    cmd: "voice",
    plan: 3,
    img: ["voice"],
    translate: "Commands.voiceDesc",
  },
  {
    cmd: "item [name]",
    plan: 2,
    img: ["item"],
    translate: "Commands.itemDesc",
  },
  {
    cmd: "cost [name]",
    plan: 2,
    img: ["cost"],
    translate: "Commands.costDesc",
  },
  {
    cmd: "tracker [name]",
    plan: 3,
    img: ["tracker", "tracker2", "tracker3"],
    translate: "Commands.trackerDesc",
  },
  {
    cmd: "add [name/steamid/steam profile]",
    plan: 3,
    img: ["add"],
    translate: "Commands.addDesc",
  },
  {
    cmd: "friends [steamid/steam profile]",
    plan: 3,
    img: [],
    translate: "Commands.friendsDesc",
  },
];
